/**
 * Offer Action Types
 */
export const ACTION_TYPES = {
  CREATED: 'CREATED',
  REVIEWED_BY_SELLER: 'REVIEWED',
  WITHDRAWN: 'WITHDRAWN',
  COUNTERED: 'COUNTERED',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  FALLOUT: 'FALLOUT',
  EXPIRED: 'EXPIRED',
  AUTO_DECLINE: 'AUTO_DECLINE',
  AUTO_WITHDRAW: 'AUTO_WITHDRAW',
}

/**
 * Offer Activity Types
 */
export const ACTIVITY_TYPES = {
  SUBMITTED: 'SUBMITTED',
  REVIEWED_BY_SELLER: 'REVIEWED',
  COUNTERED: 'COUNTERED',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  WITHDRAWN: 'WITHDRAWN',
  SELLER_CANCELED: 'SELLER_CANCELED', // not yet implemented
  FALLOUT: 'FALLOUT',
  EXPIRED: 'EXPIRED',
  AUTO_DECLINE: 'AUTO_DECLINE',
  AUTO_WITHDRAW: 'AUTO_WITHDRAW',
}

/**
 * Offer Status Labels
 */
export const OFFER_STATUS_LABEL = {
  PENDING: 'Offer Submitted',
  REVIEWED_BY_SELLER: 'Seller Reviewing',
  COUNTERED: "Seller's Final Offer",
  ACCEPTED: 'Offer Accepted',
  DECLINED: 'Declined',
  WITHDRAWN: 'Offer Withdrawn',
  EXPIRED: 'Offer Expired',
  FALLOUT: 'Sale Canceled',
  SELLER_CANCELED: 'Seller Canceled',
  AUTO_DECLINE: 'Declined',
  AUTO_WITHDRAW: 'Offer Withdrawn',
}

/**
 * Offer Statuses
 */
export const OFFER_STATUSES = {
  PENDING: 'PENDING',
  COUNTERED: 'COUNTERED',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  WITHDRAWN: 'WITHDRAWN',
  EXPIRED: 'EXPIRED',
  FALLOUT: 'FALLOUT',
  SELLER_CANCELED: 'SELLER_CANCELED', // not yet implemented
  AUTO_DECLINE: 'AUTO_DECLINE',
  AUTO_WITHDRAW: 'AUTO_WITHDRAW',
}

/**
 * Offer's user types
 */
export const USER_TYPE_LABEL = {
  BUYER: 'Buyer',
  SELLER: 'Seller',
}

/**
 * Offer's tab types
 */
export const OFFER_TAB_TYPES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  WON: 'won',
}

/**
 * Offer's types
 */
export const OFFER_TYPES = {
  COUNTER: 'COUNTER',
  INITIAL: 'INITIAL',
}

/**
 * Offer User Types
 */
export const USER_TYPES = {
  BUYER: 'BUYER',
  SELLER: 'SELLER',
  SYSTEM: 'SYSTEM',
}
